import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";


export type LabArea = {
  siteName: string;
  areaName: string;
}

const listLabAreas: Source<LabArea[]> = {
  graphql: parse(`
    query getListOfLabAreas {
      listLabAreas {
        items {
          siteName
          areaName
        }
        nextToken
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.LAB_AREAS,
    // Lab areas share the sites table, under their own partition key — the LabArea AppSync
    // data source points at it, and Query.listLabAreas.req.vtl queries modelName "LabArea".
    // So LAB_AREAS and SITES resolve to the same physical table.
    keyCondition: () => ({
      expression: "#modelName = :modelName",
      names: { "#modelName": "modelName" },
      values: { ":modelName": "LabArea" },
    }),
  },
};

export const getLabAreas = async (client: SchemaClient): Promise<LabArea[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listLabAreas);
};

export const getAndProcessLabAreas = async (client: SchemaClient): Promise<LabArea[]> => {
  const labAreas = await getLabAreas(client);
  return labAreas?.map((labArea: LabArea) => ({
    areaName: labArea.areaName,
    siteName: labArea.siteName
  })) ?? [];
};
